//@ts-nocheck
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Icon } from 'antd';
import BigNumber from 'bignumber.js';
import NumberFormat from 'react-number-format';

import { getToken } from 'utilities';
import useRefresh from 'hooks/useRefresh';
import { getTokenContractByAddress } from 'clients/contracts/getters';
import { useWeb3 } from 'clients/web3';
import MAX_UINT256 from 'constants/maxUint256';
import { TokenId } from 'types';
import { AuthContext } from 'context/AuthContext';
import WithdrawCard from './WithdrawCard';
import LoadingSpinner from '../../Basic/LoadingSpinner';
import { CardItemWrapper } from '../styles';
import WithdrawHistoryModal from './WithdrawHistoryModal';

const CardContentWrapper = styled.div`
  color: #fff;
  padding: 16px;
  .loading-spinner {
    margin: 16px 0;
  }
`;

interface CardContentProps {
  poolId: BigNumber;
  brainVaultContract: any;
  stakedToken: TokenId;
  rewardToken: TokenId;
  userStakedAmount: BigNumber;
  pendingReward: BigNumber;
  lockPeriodSecond: BigNumber;
}

function CardContent({
  poolId,
  brainVaultContract,
  stakedToken,
  rewardToken,
  userStakedAmount,
  pendingReward,
  lockPeriodSecond,
}: CardContentProps) {
  const stakedTokenDecimal = new BigNumber(10).pow(getToken(stakedToken).decimals);
  const rewardTokenDecimal = new BigNumber(10).pow(getToken(rewardToken).decimals);
  const { account } = useContext(AuthContext);
  const { fastRefresh } = useRefresh();
  const web3 = useWeb3();

  // user info
  const [stakeAmount, setStakeAmount] = useState(new BigNumber(0));
  const [userStakedTokenBalance, setUserStakedTokenBalance] = useState(new BigNumber(0));
  const [userStakedTokenAllowance, setUserStakedTokenAllowance] = useState(new BigNumber(0));
  const [pendingWithdrawals, setPendingWithdrawals] = useState();
  const [withdrawableAmount, setWithdrawableAmount] = useState(new BigNumber(0));
  const [userEligibleStakedAmount, setUserEligibleStakedAmount] = useState(new BigNumber(0));
  const [historyModalVisible, setHistoryModalVisible] = useState(false);

  const [loading, setLoading] = useState(true);

  // button loading status
  const [claimLoading, setClaimLoading] = useState(false);
  const [stakeLoading, setStakeLoading] = useState(false); // also applies to enabling

  const stakedTokenAddress = getToken(stakedToken).address;
  const rewardTokenAddress = getToken(rewardToken).address;
  const stakedTokenSymbol = getToken(stakedToken).symbol;
  const rewardTokenSymbol = getToken(rewardToken).symbol;

  // const brainVaultContract = useBrainVaultContract();
  const stakedTokenContract = getTokenContractByAddress(stakedTokenAddress, web3);

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '() => Promise<() => void>' is no... Remove this comment to see the full error message
  useEffect(async () => {
    let isMounted = true;
    let [balance, allowance, withdrawal, withdrawals] = ['0', '0', '0', [['0', '0']]];
    if (account) {
      [balance, allowance, withdrawal, withdrawals] = await Promise.all([
        stakedTokenContract.methods.balanceOf(account.address).call(),
        stakedTokenContract.methods
          .allowance(account.address, brainVaultContract.options.address)
          .call(),
        brainVaultContract.methods.getUnlockedBalance(account.address).call(),
        brainVaultContract.methods.getLockedSupplies(account.address).call(),
      ]);
    }
    // finish loading

    if (isMounted) {
      setUserStakedTokenBalance(new BigNumber(balance));
      setUserStakedTokenAllowance(new BigNumber(allowance));

      const pendingWithdrawalsTemp = withdrawals.map(withdrawal => ({
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'amount' does not exist on type 'never'.
        amount: new BigNumber(withdrawal.stakedTokenAmount),
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'lockedUntil' does not exist on type 'nev... Remove this comment to see the full error message
        lockedUntil: new BigNumber(withdrawal.unlockTime),
        eligible: true,
      }));

      // the amount of all the eligible withdrawals,
      // let's just calculated locally to avoid more network requests
      setWithdrawableAmount(new BigNumber(withdrawal));

      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ amount: BigNumber; lockedUntil... Remove this comment to see the full error message
      setPendingWithdrawals(pendingWithdrawalsTemp);

      // pending withdrawals should not be accounted into staked amount
      setUserEligibleStakedAmount(userStakedAmount.minus(0));
      setLoading(false);
    }
    return () => {
      isMounted = false;
    };
  }, [fastRefresh, account, userStakedAmount]);

  if (loading) {
    return (
      <CardContentWrapper>
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ className: string; }' is not assignable to... Remove this comment to see the full error message */}
        <LoadingSpinner className="loading-spinner" />
      </CardContentWrapper>
    );
  }

  return (
    <CardContentWrapper>
      <Row justify="end" type="flex">

        {/* stake area */}
        <Col lg={{ span: 7 }} xs={{ span: 24 }}>
          <CardItemWrapper>
            <div className="card-item stake">
              <div className="withdraw-request">
                <h3 style={{ textAlign: 'center', borderBottom: '1px solid #262b48;' }}>Stake</h3>
                <div className="card-title">
                  Available {stakedTokenSymbol} to stake:{' '}
                  {userStakedTokenBalance.div(stakedTokenDecimal).toFixed(4)}
                </div>
                <div className="input-wrapper">
                  <NumberFormat
                    autoFocus
                    value={stakeAmount.isZero() ? '0' : stakeAmount.toString(10)}
                    onValueChange={values => {
                      const value = new BigNumber(values.value || 0);
                      const maxValue = userStakedTokenBalance.div(stakedTokenDecimal).dp(4, 1);
                      setStakeAmount(value.gt(maxValue) ? maxValue : value);
                    }}
                    thousandSeparator
                    allowNegative={false}
                    placeholder="0"
                  />
                  <span
                    className="pointer max"
                    onClick={() => {
                      setStakeAmount(userStakedTokenBalance.div(stakedTokenDecimal));
                    }}
                  >
                    MAX
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="button stake-button"
                disabled={!account || /* !stakeAmount.gt(0) ||  */ stakeLoading}
                onClick={async () => {
                  setStakeLoading(true);
                  try {
                    if (!userStakedTokenAllowance.gt(0)) {
                      await stakedTokenContract.methods
                        .approve(brainVaultContract.options.address, MAX_UINT256.toFixed())
                        .send({
                          from: account?.address,
                        });
                    } else {
                      await brainVaultContract.methods
                        .deposit(stakeAmount.multipliedBy(1e18).toString(10))
                        .send({ from: account?.address });
                    }
                  } catch (e) {
                    console.log('>> stake error:', e);
                  }
                  setStakeLoading(false);
                }}
              >
                {stakeLoading && <Icon type="loading" />}{' '}
                {userStakedTokenAllowance.gt(0) ? 'Stake' : 'Enable'}
              </button>
            </div>
          </CardItemWrapper>
        </Col>

        {/* claim area */}
        <Col lg={{ span: 6 }} xs={{ span: 24 }}>
          <CardItemWrapper>
            <div className="card-item claim-rewards">
              <h3 style={{ textAlign: 'center', borderBottom: '1px solid #262b48;' }}>Rewards</h3>
              <div>
                <div className="card-title">Available Rewards</div>
                <div className="center-amount">
                  {pendingReward.div(rewardTokenDecimal).dp(6, 1).toString(10)} BRAIN
                </div>
              </div>
              <button
                type="button"
                className="button claim-button"
                disabled={!pendingReward.gt(0) || !account || claimLoading}
                onClick={async () => {
                  setClaimLoading(true);
                  try {
                    await brainVaultContract.methods
                      .claimRewards()
                      .send({ from: account?.address });
                  } catch (e) {
                    console.log('>> claim reward error:  ', e);
                  }
                  setClaimLoading(false);
                }}
              >
                {claimLoading && <Icon type="loading" />} Claim
              </button>
            </div>
          </CardItemWrapper>
        </Col>

        {/* withdraw area */}
        <Col lg={{ span: 11 }} xs={{ span: 24 }}>
          <WithdrawCard
            poolId={poolId}
            brainVaultContract={brainVaultContract}
            stakedToken={stakedToken}
            rewardTokenAddress={rewardTokenAddress}
            lockPeriodSecond={lockPeriodSecond}
            withdrawableAmount={withdrawableAmount}
            pendingWithdrawals={pendingWithdrawals}
            userEligibleStakedAmount={userEligibleStakedAmount}
          />
        </Col>
      </Row>

      <WithdrawHistoryModal
        visible={historyModalVisible}
        onCancel={() => setHistoryModalVisible(false)}
        pendingWithdrawals={pendingWithdrawals}
        withdrawableAmount={withdrawableAmount}
        stakedToken={stakedToken}
      />
    </CardContentWrapper>
  );
}

export default CardContent;
